import React, { ReactNode } from "react";
import { Box } from "../../../shared/components/ui/chakra";
import { BoxProps } from "@chakra-ui/react";

const InfoItemRight = ({
  children,
  ...props
}: { children: ReactNode } & BoxProps) => {
  return (
    <Box flex={1} minW="0%" {...props}>
      {children}
    </Box>
  );
};

export default InfoItemRight;
